var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3108",
    "data-name": "Rectangle 3108",
    width: 24,
    height: 24,
    transform: "translate(93 973)",
    fill: "#35ce77",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excelIcon",
    transform: "translate(-93 -973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M23,1.5a.938.938,0,0,1,.7.3.938.938,0,0,1,.3.7v19a1.025,1.025,0,0,1-1,1H7a1.025,1.025,0,0,1-1-1V18H1a.938.938,0,0,1-.7-.3A.938.938,0,0,1,0,17V7a.938.938,0,0,1,.3-.7A.918.918,0,0,1,1,6H6V2.5a.938.938,0,0,1,.3-.7A.938.938,0,0,1,7,1.5ZM6,13.28l1.42,2.66H9.56L7.18,12.07l2.34-3.8H7.46l-1.3,2.4-.05.08-.04.09L5.43,9.56,4.77,8.27H2.59l2.27,3.82L2.38,15.94H4.54ZM14.25,21V18H7.5v3Zm0-4.5V12.75H12V16.5Zm0-5.25V7.5H12v3.75Zm0-5.25V3H7.5V6ZM22.5,21V18H15.75v3Zm0-4.5V12.75H15.75V16.5Zm0-5.25V7.5H15.75v3.75ZM22.5,6V3H15.75V6Z",
    transform: "translate(93 973)",
    fill: "#35ce77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.5b282dcc581af6e2af0bfbe3db0eb521.svg";
export { ForwardRef as ReactComponent };